<template>
<section class="contact-component">
  <div class="contact-component__container">
    <div class="contact-component__info">
      <ul class="contact-component__info-details">
        <li>
          <p>BOGUSŁAW JURASZEK</p><br>
          <strong>PREZES ZARZĄDU</strong><br><br>
        </li>
        <li class="contact-component__with-icon">
          <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="20pt" height="20pt" viewBox="0 0 241.061 241.061" style="enable-background:new 0 0 241.061 241.061;"
            xml:space="preserve">
            <g>
              <path style="fill:#e61919;" d="M198.602,70.402l-78.063,68.789l-78.08-68.79c-3.109-2.739-7.848-2.438-10.586,0.669c-2.737,3.108-2.439,7.847,0.67,10.586
                l83.039,73.159c1.417,1.248,3.188,1.872,4.958,1.872s3.542-0.624,4.959-1.873l83.022-73.159c3.107-2.738,3.406-7.478,0.668-10.586
                C206.449,67.964,201.711,67.664,198.602,70.402z" />
              <path style="fill:#e61919;" d="M218.561,38.529H22.5c-12.406,0-22.5,10.093-22.5,22.5v119.002c0,12.407,10.094,22.5,22.5,22.5h196.061
                c12.406,0,22.5-10.093,22.5-22.5V61.029C241.061,48.623,230.967,38.529,218.561,38.529z M226.061,180.031
                c0,4.135-3.364,7.5-7.5,7.5H22.5c-4.136,0-7.5-3.365-7.5-7.5V61.029c0-4.135,3.364-7.5,7.5-7.5h196.061c4.136,0,7.5,3.365,7.5,7.5
                V180.031z" />
            </g>
          </svg>
          <a href="mailto:boguslaw.juraszek@elbologistyka.pl"><span class="contact-component__with-icon--text">boguslaw.juraszek@elbologistyka.pl</span></a>
        </li>
        <li class="contact-component__with-icon">
          <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="20pt" height="20pt" viewBox="0 0 241.061 241.061" style="enable-background:new 0 0 241.061 241.061;"
            xml:space="preserve">
            <g>
              <path style="fill:#e61919;" d="M198.602,70.402l-78.063,68.789l-78.08-68.79c-3.109-2.739-7.848-2.438-10.586,0.669c-2.737,3.108-2.439,7.847,0.67,10.586
                l83.039,73.159c1.417,1.248,3.188,1.872,4.958,1.872s3.542-0.624,4.959-1.873l83.022-73.159c3.107-2.738,3.406-7.478,0.668-10.586
                C206.449,67.964,201.711,67.664,198.602,70.402z" />
              <path style="fill:#e61919;" d="M218.561,38.529H22.5c-12.406,0-22.5,10.093-22.5,22.5v119.002c0,12.407,10.094,22.5,22.5,22.5h196.061
                c12.406,0,22.5-10.093,22.5-22.5V61.029C241.061,48.623,230.967,38.529,218.561,38.529z M226.061,180.031
                c0,4.135-3.364,7.5-7.5,7.5H22.5c-4.136,0-7.5-3.365-7.5-7.5V61.029c0-4.135,3.364-7.5,7.5-7.5h196.061c4.136,0,7.5,3.365,7.5,7.5
                V180.031z" />
            </g>
          </svg>
          <a href="mailto:biuro@elbologistyka.pl"><span class="contact-component__with-icon--text">biuro@elbologistyka.pl</span></a>
        </li>
        <li class="contact-component__with-icon">
          <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="20pt" height="20pt" viewBox="0 0 211.621 211.621" style="enable-background:new 0 0 211.621 211.621;"
            xml:space="preserve">
            <g>
              <path style="fill:#e61919;"
                d="M180.948,27.722C163.07,9.844,139.299-0.001,114.017,0c-4.143,0-7.5,3.358-7.5,7.5c0,4.142,3.358,7.5,7.5,7.5c21.276-0.001,41.279,8.284,56.324,23.329c15.046,15.045,23.331,35.049,23.33,56.326c0,4.142,3.357,7.5,7.5,7.5c4.142,0,7.5-3.358,7.5-7.499C208.672,69.371,198.827,45.6,180.948,27.722z" />
              <path style="fill:#e61919;"
                d="M150.096,94.656c0,4.142,3.358,7.5,7.501,7.499c4.142,0,7.499-3.358,7.499-7.5c-0.002-28.16-22.916-51.073-51.078-51.077c-0.001,0,0,0-0.001,0c-4.142,0-7.499,3.357-7.5,7.499c0,4.142,3.357,7.5,7.499,7.501C133.909,58.581,150.094,74.765,150.096,94.656z" />
              <path style="fill:#e61919;"
                d="M133.5,132.896c-11.432-0.592-17.256,7.91-20.049,11.994c-2.339,3.419-1.463,8.086,1.956,10.425c3.419,2.339,8.086,1.463,10.425-1.956c3.3-4.825,4.795-5.584,6.823-5.488c6.491,0.763,32.056,19.497,34.616,25.355c0.642,1.725,0.618,3.416-0.071,5.473c-2.684,7.966-7.127,13.564-12.851,16.188c-5.438,2.493-12.105,2.267-19.276-0.651c-26.777-10.914-50.171-26.145-69.531-45.271c-0.008-0.008-0.016-0.015-0.023-0.023c-19.086-19.341-34.289-42.705-45.185-69.441c-2.919-7.177-3.145-13.845-0.652-19.282c2.624-5.724,8.222-10.167,16.181-12.848c2.064-0.692,3.752-0.714,5.461-0.078c5.879,2.569,24.612,28.133,25.368,34.551c0.108,2.104-0.657,3.598-5.478,6.892c-3.42,2.336-4.299,7.003-1.962,10.423c2.336,3.42,7.002,4.298,10.423,1.962c4.086-2.79,12.586-8.598,11.996-20.069C81.021,69.07,57.713,37.339,46.576,33.244c-4.953-1.846-10.163-1.878-15.491-0.09C19.097,37.191,10.439,44.389,6.047,53.969c-4.26,9.294-4.125,20.077,0.395,31.189c11.661,28.612,27.976,53.647,48.491,74.412c0.05,0.051,0.101,0.101,0.153,0.15c20.75,20.477,45.756,36.762,74.33,48.409c5.722,2.327,11.357,3.492,16.746,3.492c5.074,0,9.932-1.032,14.438-3.098c9.581-4.391,16.778-13.048,20.818-25.044c1.784-5.318,1.755-10.526-0.077-15.456C177.232,156.856,145.501,133.548,133.5,132.896z" />
            </g>
          </svg>
          <a href="tel:0048515216203"><span class="contact-component__with-icon--text">+48 515 216 203</span></a>
        </li><br>
        <li class="contact-component__with-icon">
          <strong>ELBO LOGISTYKA Sp. z o.o.</strong><br>
        </li>
        <li>
          <p>Ul. Nad Sołą 1005<br>34-382 Wieprz<br>NIP: 629-242-44-53</p>
        </li>
      </ul>
    </div>
    <div class="contact-component__form">
      <form
        accept-charset="UTF-8"
        v-on:submit.prevent="onSubmit()"
        method="POST"
        enctype="multipart/form-data"
        id="ajaxForm">
        <div class="contact-component__field">
          <label for="inputName">IMIĘ I NAZWISKO:</label>
          <input type="text"
                 id="inputName"
                 name="name"
                 v-model="name"
                 required>
        </div>

        <div class="contact-component__field">
          <label for="inputEmail">EMAIL:</label>
          <input type="email"
                 id="inputEmail"
                 name="email"
                 v-model="email"
                 required>
        </div>

        <div class="contact-component__field">
          <label for="inputMore">TREŚĆ WIADOMOŚCI:</label>
          <textarea id="inputMore"
                    name="more"
                    v-model="more"
                    required>
          </textarea>
        </div>
        <!-- <div class="contact-component__field">
          <label class="mr-2">DOŁĄCZ PLIK <span>(max 5MB)</span></label>
          <input type="file" @change="processFile($event)">
        </div> -->
        <div class="contact-component__agree">
          <input type="checkbox" name="agree" value="submit" class="checkbox" required/>
            <p class="contact-component__agree-info">Wyrażam zgodę na przetwarzanie danych osobowych zgodnie z ustawą o ochronie danych osobowych w związku z wysyłaniem zapytania przez formularz kontaktowy. Podanie danych jest dobrowolne, ale niezbędne do
            przetworzenia zapytania.
            Zostałem poinformowany, że przysługuje mi prawo do dostępu do swoich danych, możliwości ich poprawiania, żądania zaprzestania ich przetwarzania. Administratorem danych osobowych jest firma Elbo Logistyka Sp. z o.o.</p>

        </div>
        <div class="contact-component__success"
             v-if="isSuccess">
             <p>Dziękujemy! Twoja wiadomość została wysłana!</p>
        </div>
        <div>
          <button class="button" type="submit">WYŚLIJ</button>
        </div>
      </form>
    </div>
  </div>
</section>
</template>

<script>
import axios from "axios"

export default {
  name: 'ContactComponent',
  components: {},
  data() {
    return {
      message: "",
      loading: true,
      name: "",
      email: "",
      // files: [],
      more: "",
      isSuccess: false
    };
  },
  methods: {
    // processFile(event) {
    //   this.files = event.target.files[0];
    // },
    onSubmit() {
      this.message = "";
      let data = {
        name: this.name,
        email: this.email,
        more: this.more,
        file: this.files
      }
      axios
        .post("https://getform.io/f/7aa68cc4-e739-41d9-b152-7fbdb6aa19cc", data, {
          headers: {
            Accept: "application/json"
          }
        })
        .then(
          response => {
            this.isSuccess = response.data.success ? true : false;
          }
          // response => {
          //   // Error
          // }
        );
    }
  }
  // props: {
  //   blockContent: {
  //     type: Object,
  //     default: function() {
  //       return {}
  //     }
  //   }
  // }
}
</script>

<style lang="sass">
  @import 'src/assets/stylesheets/style.sass'
</style>
